import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/articles';

interface ArticleCardProps {
  article: ArticleItem;
  variant?: 'default' | 'featured';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/30 hover:border-primary-500/30 transition-all duration-300"
      >
        <div className="relative aspect-[2/1] overflow-hidden">
          <img
            src={article.thumbnail}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
            <span className="inline-block px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded mb-2 whitespace-nowrap">
              {article.category === 'movie' ? '精选电影' : article.category === 'drama' ? '热门剧集' : article.category === 'anime' ? '动漫动画' : article.category === 'documentary' ? '纪录纪实' : article.category === 'variety' ? '综艺娱乐' : '短视频'}
            </span>
            <h3 className="text-base md:text-lg font-semibold text-white line-clamp-2 group-hover:text-primary-300 transition-colors duration-200">
              {article.title}
            </h3>
            <p className="text-xs text-white/70 mt-1 line-clamp-2 hidden sm:block">{article.excerpt}</p>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex gap-3 md:gap-4 p-3 rounded-lg bg-background-100 border border-background-200/30 hover:border-primary-500/30 transition-all duration-300"
    >
      <div className="w-32 md:w-40 h-20 md:h-24 flex-shrink-0 rounded-md overflow-hidden">
        <img
          src={article.thumbnail}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
          {article.title}
        </h4>
        <p className="text-xs text-foreground-400 mt-1 line-clamp-2 hidden sm:block">{article.excerpt}</p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
          <span>{article.author}</span>
          <span>{article.date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
          </span>
        </div>
      </div>
    </Link>
  );
}